enum QueueEventEnum {
  promoteAdmin = 9,
  revokeAdmin = 10,
  trustedPortalActivated = 62,
}

export default QueueEventEnum;
